import { render, staticRenderFns } from "./ochartComponent.vue?vue&type=template&id=2e54f68d&scoped=true"
import script from "./ochartComponent.vue?vue&type=script&lang=js"
export * from "./ochartComponent.vue?vue&type=script&lang=js"
import style0 from "./ochartComponent.vue?vue&type=style&index=0&id=2e54f68d&prod&lang=css"
import style1 from "../../statistics/css/departmentOchart.css?vue&type=style&index=1&id=2e54f68d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e54f68d",
  null
  
)

export default component.exports